module.exports = __webpack_public_path__ + "img/Layer_7.9432bf32.png";